import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { RegisterUser } from '../../models/user-center.model';
import { ForgotPasswordService } from './forgot-password.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html'
})
export class ForgotPasswordComponent {
  forgotPasswordForm: FormGroup = new FormGroup({
    emailId: new FormControl('', [
      Validators.required,
      Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$")
    ])
  });

  constructor(private forgotPasswordService: ForgotPasswordService,
              private toasterService: ToastrService,
              private router: Router
             ) {}
  forgotPassword(){
    let userDetails: RegisterUser = {
      emailId: this.forgotPasswordForm.controls['emailId'].value
    }
    this.forgotPasswordService.forgotPassword(userDetails).subscribe((response: any)=>{
      if (response.isSuccess) {
        this.toasterService.success('Reset password link sent to registered email', 'Success');
        setTimeout(() => {
          this.router.navigate(['/login']);
        }, 2000)
      }
    }, (errorResponse: HttpErrorResponse) => {
      if(errorResponse.error){
        this.toasterService.error(errorResponse.error, "Error");
      }
    })
  }
}
